import { useTranslate } from '@i18n';
import { Button, ClubSelectionTabs, Heading2, Inline } from '@ui';

import { BACK_NAV_HEIGHT } from './ClubSelection.css';
import { useDisplayMode } from './useDisplayMode';

type ClubSelectionControlsProps = {
    onSave: () => void;
    onCancel: () => void;
    isLoading?: boolean;
};

export const ClubSelectionControls = ({ isLoading, onSave, onCancel }: ClubSelectionControlsProps) => {
    const { displayMode, setDisplayMode } = useDisplayMode();
    const t = useTranslate();

    return (
        <Inline justifyContent="space-between" alignItems="center" style={{ height: BACK_NAV_HEIGHT }}>
            <Heading2 weight={700}>{t('club_selection.title')}</Heading2>
            <ClubSelectionTabs displayMode={displayMode} onSelect={setDisplayMode} />
            <Inline>
                <Button variant="secondary" onClick={onCancel}>
                    {t('generic_ui.cancel')}
                </Button>
                <Button variant="primary" isLoading={isLoading} onClick={onSave}>
                    {t('generic_ui.save')}
                </Button>
            </Inline>
        </Inline>
    );
};
